"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DRAGGABLE_VALUES = void 0;
var DRAGGABLE_VALUES = Object.freeze({
  TRUE: 'true',
  FALSE: 'false',
  AUTO: 'auto'
});
exports.DRAGGABLE_VALUES = DRAGGABLE_VALUES;